import React, {Component} from 'react';
import SquareButton from "../../../components/SquareButton";
import Select from "../../../local_node_modules/react-select"

class UserAliasInfo extends Component {

	constructor (props) {
		super(props);
		this.state = {
			isMobile : window.innerWidth > 991 ? false : true
		};
	}

	render () {
		const { isMobile } = this.state;
		return (
			<div>
				<div className='col-sm-12 row card-header' style={{margin: '0 0 0 0', padding: '20px 0 0 20px'}}>
					<div className='col-sm-6'>
						<h6 className="card-title" style={{textTransform: 'none'}}>Etiketler</h6>
					</div>

					<div className='col-sm-6'>
						<SquareButton title='Kaydet' img='save.png'
									  style={{background: 'linear-gradient(rgba(154, 193, 218, 0.61), #6e8da2)', float: 'right', margin: !isMobile ? '-5px 0 10px 0': "-5px 25px 10px 0px"}}
									  onClick={this.props.handleChangeUserAliasList}/>
					</div>
				</div>

				<div className='col-sm-12' style={{marginTop: '20px'}}>
					<Select
						className="select-control"
						name="alias"
						id="tAlias"
						multi={true}
						inputProps={{'vdata': "required"}}
						ref="tAlias"
						placeholder="Seçiniz..."
						value={this.props.selectedAliasList}
						onChange={(e) => this.props.onChangeAlias(e)}
						options={this.props.userAliasList}
					/>
				</div>
			</div>
		)
	}
}

export default UserAliasInfo;